import Button from 'components/Button'
import Icon from 'components/Icon'
import { BellIcon } from 'components/Icon/icons/bell'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'

class NotificationButton extends React.Component {
  static SIZE = Icon.SIZE

  static defaultProps = {
    value: 0
  }

  static propTypes = {
    value: PropTypes.number,
    onClick: PropTypes.func
  }

  renderIcon () {
    return (
      <div>
        <Icon
          icon={BellIcon}
          size={this.props.size}
          color={this.props.value ? STYLES_COLOR.BLUE : null}
        />
      </div>
    )
  }

  renderContent () {
    if (!this.props.onClick) {
      return (
        <>
          {this.renderIcon()}
        </>
      )
    }
    return (
      <Button onClick={this.props.onClick}>
        {this.renderIcon()}
      </Button>
    )
  }

  render () {
    return (
      <div
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxSizing: 'border-box',
          height: '1.88em',
          width: '1.88em'
        }}
      >
        {this.renderContent()}
      </div>
    )
  }
}

export default NotificationButton
